var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16v-1.792L10.292 10 6 5.792V4h8v2H8.833l4 4-4 4H14v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageIcon);
export default __webpack_public_path__ + "static/media/average-icon.4d585dea0963568f56eeb5fd922c5d82.svg";
export { ForwardRef as ReactComponent };